<template>
	<v-card class="mb-1" :loading="saving">
		<v-card-text>
			<v-list-item>
				<v-list-item-icon v-if="payment.method" class="mr-3" style="width: 80px">
					<img
						v-if="payment.method == 'mbw'"
						style="max-height: 30px"
						src="data:image/png;base64,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"
					/>
					<img
						v-if="payment.method == 'mb'"
						style="max-height: 30px"
						src="data:image/png;base64,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"
					/>
					<img
						v-if="payment.method == 'cc'"
						style="max-height: 30px; max-width: 80px"
						src="https://www.easypay.pt/static/img/5.656e359.png"
					/>
					<img
						v-if="payment.method == 'bt'"
						style="max-height: 30px"
						:src="require('../../assets/images/' + 'bank_transfer_logo.png')"
					/>
				</v-list-item-icon>
				<v-list-item-content>
					<v-list-item-subtitle>
						<v-row no-gutters>
							<v-col>
								<template v-if="payment.modules.length > 0">
									<div v-for="item in payment.modules" :key="item.module" class="mb-2">
										<b>{{item.module}}</b>
										|
										<template v-if="item.duration != 0">
											{{item.duration}}
											<translate v-if="item.duration == 1">Month</translate>
											<translate v-else>Months</translate>
											<template v-if="item.days && item.days > 0">
												+ {{item.days}}
												<translate>Days</translate>
											</template>
										</template>
										<template v-else>
											{{item.days}}
											<translate>Days</translate>
										</template>
										: {{item.price}}€
										<br />
									</div>
								</template>
								<div v-else-if="payment.sms_quantity > 0" class="mb-2">
									<b>{{payment.sms_quantity}} SMS</b>
								</div>
								<div v-else-if="payment.days && payment.days > 0" class="mb-2">
									<b v-if="payment.free">Plano Grátis</b>
									<b v-else>Extensão de Plano</b> |
									{{payment.days}}
									<translate v-if="payment.days == 1">Day</translate>
									<translate v-else>Days</translate>
								</div>
								<div v-else>
									<b>Upgrade</b>
								</div>
							</v-col>
							<v-col>
								<template v-if="payment.method == 'mb'">
									<span class="font-weight-bold mr-1" v-translate key="entity">Entity:</span>
									{{payment.entity}}
									<br />
									<span class="font-weight-bold mr-1" v-translate key="reference">Reference:</span>
									{{payment.reference}}
								</template>
								<template v-else-if="payment.method == 'mbw'">
									<span class="font-weight-bold mr-1" key="phone">
										<translate>Phone</translate>:
									</span>
									{{payment.phone_number}}
									<br />
								</template>
								<template v-else-if="payment.method == 'bt'">
									<span class="font-weight-bold mr-1" key="phone">
										<translate>IBAN</translate>:
									</span>
									{{payment.iban}}
									<br />
								</template>
							</v-col>
							<v-col v-if="payment.method == 'bt'">
								<template v-if="payment.comprovative">
									<v-btn
										color="primary"
										text
										@click="openFile(payment.comprovative)"
										:disabled="saving"
										small
										>
										<translate>Comprovative</translate>
										<v-icon small class="ml-1">mdi-note</v-icon>
									</v-btn>
									<v-btn
                    v-if="!admin"
                    color="primary"
                    icon
                    @click="removeComprovative"
                    :disabled="saving"
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
								</template>
								<template v-else>
									<span v-if="admin" class="font-weight-light">Sem comprovativo.</span>
									<VueFileAgent
											v-else
											ref="vueFileAgent"
											:theme="'list'"
											:multiple="false"
											:deletable="true"
											:meta="true"
											:accept="'image/*,.pdf,.doc,.docx'"
											:maxSize="'50MB'"
											:maxFiles="1"
											:helpText="$gettext('Add proof')"
											:errorText="{
												type: 'Invalid file type. Only images and PDFs are allowed',
												size: 'Files cannot exceed 50MB in size'
											}"
											@select="filesSelected($event)"
											@beforedelete="onBeforeDelete($event)"
											v-model="fileRecords"
									></VueFileAgent>
								</template>
								<v-btn
									v-if="admin && payment.status == 'pending'"
                  color="primary"
                  text
                  @click="confirmPayment"
									small
                >
                  Confirmar
                  <v-icon small class="ml-1">mdi-check-circle</v-icon>
                </v-btn>
							</v-col>
              <v-col v-if="!payment.free">
                <template v-if="payment.receipt">
                  <v-btn
                    color="primary"
                    text
                    @click="openFile(payment.receipt)"
                    :disabled="saving"
										small
                  >
                    <translate>Receipt</translate>
                    <v-icon small class="ml-1">mdi-receipt</v-icon>
                  </v-btn>
                  <v-btn
                    v-if="admin"
                    color="primary"
                    icon
                    @click="removeReceipt"
                    :disabled="saving"
										small
                  >
                    <v-icon small>mdi-delete</v-icon>
                  </v-btn>
                </template>
                <div v-else-if="admin">
                  <VueFileAgent
                    ref="vueFileAgent"
                    :theme="'list'"
                    :multiple="false"
                    :deletable="true"
                    :meta="true"
                    :accept="'image/*,.pdf,.doc,.docx'"
                    :maxSize="'50MB'"
                    :maxFiles="1"
                    :helpText="$gettext('Drag or click')"
                    :errorText="{
                      type: 'Invalid file type. Only images and PDFs are allowed',
                      size: 'Files cannot exceed 50MB in size'
                    }"
                    @select="filesSelected($event)"
                    @beforedelete="onBeforeDelete($event)"
                    v-model="fileRecords"
                  ></VueFileAgent>
                </div>
              </v-col>
						</v-row>
						<v-row no-gutters v-if="payment.subscription_plan">
							<translate>Plan</translate>
							: {{payment.subscription_plan.name}}
						</v-row>
						{{payment.date}}
					</v-list-item-subtitle>
				</v-list-item-content>
				<v-list-item-action :class="statusColor">
          <v-row v-if="showSpace" no-gutters align="center" justify="center">
            <v-col style="min-width: 100px">
              <strong>{{status}}</strong><br>
              <span v-if="!payment.free">Total: {{payment.value}} €</span>
            </v-col>
            <v-col>
              <v-btn icon color="primary" :to="{name: 'manage-space', params: {sid: payment.space_id}}">
                <v-icon>mdi-chevron-right</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <template v-else>
            <strong>{{status}}</strong>
            <span style="min-width: 50px" v-if="!payment.free">Total: {{payment.value}} €</span>
          </template>
				</v-list-item-action>
			</v-list-item>
		</v-card-text>
	</v-card>
</template>

<script>
import axios from "axios";

export default {
  name: "PaymentItem",
  props: ["payment", "admin", "showSpace"],
  data: () => ({
    fileRecords: [],
    fileRecordsForUpload: [],
    saving: false
  }),
  computed: {
    statusColor() {
			if (this.payment.status === "paid") return "primary--text";
			if (this.payment.status === "pending") return "orange--text";
			else return "red--text";
		},
		status() {
			if (this.payment.free) return this.$gettext("Free");
			else if (this.payment.status === "paid") return this.$gettext("Paid");
			else if (this.payment.status === "pending") return this.$gettext("Pending");
			else return this.$gettext("Failed");
		}
  },
  methods: {
    filesSelected(fileRecordsNewlySelected) {
      var validFileRecords = fileRecordsNewlySelected.filter((fileRecord) => !fileRecord.error);
      this.fileRecordsForUpload = validFileRecords;
      if(this.fileRecordsForUpload.length > 0) {
				if(this.admin) this.addReceipt();
				else this.addComprovative();
			}
		},
		onBeforeDelete(fileRecord) {
			var h = this.fileRecords.indexOf(fileRecord);
      if (h !== -1) {
				this.fileRecords.splice(h, 1);
			}
			var i = this.fileRecordsForUpload.indexOf(fileRecord);
      if (i !== -1) {
				this.fileRecordsForUpload.splice(i, 1);
			}
    },
    addReceipt() {
      let form = new FormData();
      form.append('receipt', this.fileRecordsForUpload[0].file);
      this.saving = true;
      axios
				.post("/admin/payments/" + this.payment.id + "/add-receipt", form)
				.then(response => {
					if (response.data.result == 'ok') {
            this.payment.receipt = response.data.receipt;
          }
          this.saving = false;
          this.fileRecords = [];
          this.fileRecordsForUpload = [];
				})
				.catch(error => {
          console.log(error);
          this.saving = false;
				});
    },
    removeReceipt() {
      this.saving = true;
      axios
				.post("/admin/payments/" + this.payment.id + "/remove-receipt")
				.then(response => {
					if (response.data.result == 'ok') {
						this.payment.receipt = response.data.receipt;
          }
          this.saving = false;
				})
				.catch(error => {
          console.log(error);
          this.saving = false;
				});
    },
    openFile(code) {
			axios
				.get("/download/" + code)
				.then(response => {
					if (response.status === 200) {
						var link = document.createElement("a");
            link.href = "https://api.naltio.com/download/" + code;
            //link.href = "http://127.0.0.1:5500/download/" + code;
						link.target = "_self";
						document.body.appendChild(link);
						link.click();
					}
				})
				.catch(error => {
					console.log(error);
				});
    },
		addComprovative() {
			let form = new FormData();
      form.append('comprovative', this.fileRecordsForUpload[0].file);
      this.saving = true;
      axios
				.post("/admin/payments/" + this.payment.id + "/add-comprovative", form)
				.then(response => {
					if (response.data.result == 'ok') {
            this.payment.comprovative = response.data.comprovative;
          }
          this.saving = false;
          this.fileRecords = [];
          this.fileRecordsForUpload = [];
				})
				.catch(error => {
          console.log(error);
          this.saving = false;
				});
		},
		removeComprovative() {
      this.saving = true;
      axios
				.post("/admin/payments/" + this.payment.id + "/remove-comprovative")
				.then(response => {
					if (response.data.result == 'ok') {
						this.payment.comprovative = response.data.comprovative;
          }
          this.saving = false;
				})
				.catch(error => {
          console.log(error);
          this.saving = false;
				});
    },
		confirmPayment() {
			axios
				.post("/admin/payments/" + this.payment.id + "/confirm")
				.then(response => {
					if (response.data.result == 'OK') {
						this.payment.status = 'paid';
          }
				})
				.catch(error => {
          console.log(error);
				});
		}
  }
}
</script>